document.addEventListener('DOMContentLoaded', () => {
	initFunctions();
});

function initFunctions() {
	const backgroundIcons = document.querySelector('.background-icons');
	if (backgroundIcons != null) {
		animateBackgroundIcons(backgroundIcons);
	}
}

function animateBackgroundIcons(div) {
	const icons = div.querySelectorAll('img');

	icons.forEach((icon, i) => {
		setTimeout(() => {
			animateIcon(icon);
		}, i * 400);
	});
}

function animateIcon(icon) {
	icon.classList.add('visible');
	icon.style.scale = 3;
	setTimeout(() => {
		icon.style.scale = 1;
	}, 400);
}
